module.exports = __webpack_public_path__ + "img/nl.e877881e.svg";